import $ from '../$';
import each from '../functions/each';
import { ajaxEvents } from '../functions/utils/ajax';
import './on';
each(ajaxEvents, (name, eventName) => {
    $.fn[name] = function (fn) {
        return this.on(eventName, (e, params) => {
            fn(e, params.xhr, params.options, params.data);
        });
    };
});
